import "flatpickr/dist/flatpickr.min.css";
// css imports

import { notify } from "./../helper/notify";
import { humanDate } from "./../helper/humanDate";
import { buildKitEditor } from "./../helper/buildKitEditor";
import { request } from "./../helper/request";
import { modal } from "./../helper/modal";
import { urlId, lang, caret_black, placeholder } from "../app";
// some imports from App.js

import "./../img/fleet.jpg";
const fleet = "/dist/img/fleet.jpg";
// import and assign static images

let userLevel = "",
	admin = false,
	kits = [],
	author,
	id = urlId;
const videoSVG = `<svg viewBox="0 0 47 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 19.91V1H46V28.57H10.75" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.1 9.21003V6.84003L30.78 14.78L19.1 22.73V17.4" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.5 28.99V35.45" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.99 35.66H29.01" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const imageSVG = `<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 47 37"><defs><style>.st0 {fill: none;stroke: #898d8d;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.25px;}</style></defs><path class="st0" d="M40.16,24.71l-4.66-5.11-7.43,7.69-11.88-13.42L3.5,25.41V3.88h40v29.23H12.17"/><path class="st0" d="M21.84,14.91c.6-1.12,1.77-1.89,3.14-1.92,2.03-.05,3.72,1.55,3.77,3.58.04,1.49-.81,2.79-2.06,3.4"/></svg>`;
const imagesSVG = `<svg viewBox="0 0 47 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.7 27.86L31.29 23.02L24.26 30.3L13.02 17.6L1 28.53V8.15002H38.86V35.82H9.21" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.36 18.59C18.93 17.53 20.04 16.8 21.33 16.77C23.25 16.72 24.85 18.24 24.9 20.16C24.94 21.57 24.13 22.8 22.95 23.38" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M42.52 32.15V4.47998H4.66003V8.14998" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M46 28.67V1H8.14001V4.48" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const docSVG = `<svg viewBox="0 0 35 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.6037 1H1V37.765" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.465 46H33.895V9.27997" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M33.895 9.28H25.6038V1L33.895 9.28Z" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.76123 13.3188H17.4475" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.76123 23.59H27.1337" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.76123 28.72H27.1337" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.76123 18.46H27.1337" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.76123 33.85H27.1337" stroke="#898D8D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const kitsWrapper = $("#kits_list_wrapper").attr("build", window.isMobile ? "mobile" : "desktop");
let kitButton = $(`<button id="createKitButton" class="uk-button uk-button-primary">${id ? "Edit" : "Create"} Media Kit</span></button>`);
const loadMoreBtnWrapper = $("#kits_load_more_wrapper");

const gridCt = 4;

const sortKits = (sort = "desc") => {
	kits.sort((a, b) => {
		if (a.langs[lang] && b.langs[lang]) {
			const aVal = a.langs[lang].sortIndex;
			const bVal = b.langs[lang].sortIndex;
			return aVal > bVal ? (sort === "asc" ? -1 : 1) : aVal < bVal ? (sort === "asc" ? 1 : -1) : 0;
		} else {
			return 0;
		}
	});
	// sort kits desc by pubTime
};
// end sortKits function

window.renderContent = async user => {
	userLevel = user.userLevel;
	author = `${user.gacUser.firstname} ${user.gacUser.lastname}`;
	admin = userLevel === "admin";
	if (admin) {
		$("#kits_admin_wrapper").removeClass("hidden");
	}
	let params;
	if (admin) {
		params = id
			? {
					// getting single kit
					reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
					datatype: "kit",
					keyAdd: "AND #id = :id",
					namesAdd: {
						"#id": "id"
					},
					valuesAdd: {
						":id": id
					}
			  }
			: {
					// getting all kits
					reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
					datatype: "kit"
			  };
	} else {
		params = id
			? {
					// public getting single kit
					reqId: "644bff17-8cd7-46ea-b103-8d98ac019eaa",
					datatype: "kit",
					keyAdd: "AND #id = :id",
					namesAdd: {
						"#id": "id"
					},
					valuesAdd: {
						":id": id
					}
			  }
			: {
					// public getting all kits
					reqId: "644bff17-8cd7-46ea-b103-8d98ac019eaa",
					datatype: "kit",
					namesAdd: {
						"#langs": "langs",
						"#lang": lang,
						"#status": "status",
						"#pubTime": "pubTime"
					},
					valuesAdd: {
						":true": true,
						":now": new Date().getTime()
					},
					filter: "#langs.#lang.#status = :true AND #langs.#lang.#pubTime <= :now"
			  };
	}
	try {
		const response = await request(params);
		kits = response;
		$("body").find(".dimmer").remove();
		if (id) {
			presentKit(kits, id);
		} else {
			sortKits();
			if (admin) {
				const kitsAdminWrapper = $("#kits_admin_wrapper");
				if (!$("#createKitButton").length) {
					kitsAdminWrapper.append(kitButton);
					kitButton.on("click", function (e, data) {
						const cb = _kits => {
							kits = _kits;
							sortKits();
							presentKits();
						};
						buildKitEditor($(this), kits, data && data.id ? data.id : id, lang, author, userLevel, cb);
					});
					// create/edit kit button click handler
				}
				if (!$("#sortKitsButton").length) {
					kitsAdminWrapper.append(`<button id="sortKitsButton" class="uk-button uk-button-primary uk-margin-small-left">Sort Kits</button>`);
				}
			}
			// add create/edit button if it doesn't exist

			presentKits();
		}
	} catch (err) {
		$("body").find(".dimmer").remove();
		console.error(err);
	}
};
// end renderContent function

// MARK: Present single kit
const presentKit = async (kits, id) => {
	let kit = kits.find(item => item.id === id);
	if (kit) {
		const kitData = kit.langs[lang];
		kitsWrapper.addClass("hidden");
		$("#kit_header").text(kitData.name);
		$("#kit_wrapper").removeClass("hidden");

		const releasesWrapper = $("#kit_releases_wrapper").html("");
		if (kitData.releases && kitData.releases.length) {
			// there are release IDs
			let foundReleases = [];
			for (let i = 0; i < kitData.releases.length; i++) {
				const id = kitData.releases[i].id;
				const response = await request(
					admin
						? {
								reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
								datatype: "release",
								keyAdd: "AND #id = :id",
								namesAdd: {
									"#id": "id"
								},
								valuesAdd: {
									":id": id
								}
						  }
						: {
								reqId: "644bff17-8cd7-46ea-b103-8d98ac019eaa",
								datatype: "release",
								keyAdd: "AND #id = :id",
								filter: "#langs.#lang.#status = :true AND #langs.#lang.#pubTime <= :now",
								namesAdd: {
									"#id": "id",
									"#langs": "langs",
									"#lang": lang,
									"#pubTime": "pubTime",
									"#status": "status"
								},
								valuesAdd: {
									":id": id,
									":now": new Date().getTime(),
									":true": true
								}
						  },
					releasesWrapper
				);
				if (response.length) {
					foundReleases = foundReleases.concat(
						response.map(item => ({
							id: item.id,
							headline: item.langs[lang].headline,
							pubTime: item.langs[lang].pubTime,
							status: item.langs[lang].status,
							images: item.langs[lang].images
						}))
					);
				}
			}
			if (foundReleases.length) {
				foundReleases.forEach(release => {
					let link = `/${lang}/news/?id=${release.id}`;
					const image = release.images && release.images.length ? release.images[0] : "";
					const thumb = image ? (image.customthumb ? image.customthumb : image.preview ? image.preview : image.thumb) : "";
					releasesWrapper.append(`<a href="${link}" target="_blank" class="release_wrapper">               
								${
									thumb
										? `<div class="release_image_wrapper uk-cover-container">
									<img uk-cover uk-img data-src="${thumb}">
								</div>`
										: ""
								}
								<div class="release_copy_wrapper${thumb ? "" : " no-thumb"}">
								<div class="release_date">${humanDate(release.pubTime, false)}${release.status ? "" : `<span class="uk-text-small uk-margin-small-left admin-only">Inactive</span>`}${release.pubTime > new Date().getTime() ? `<span class="uk-text-small uk-margin-small-left admin-only">Published in Advance</span>` : ""}</div>
					<div class="release_headline"><span class="text">${release.headline}</span>&nbsp;<span class="release_caret">${caret_black}</span></div>                
					</div>
				</a>`);
				});
			} else {
				releasesWrapper.html("This media kit contains no news releases");
			}
		} else {
			releasesWrapper.html("This media kit contains no news releases.");
		}
		// present releases, if any

		const resourcesWrapper = $("#kit_resources_wrapper");
		if (kitData.docs && kitData.docs.length) {
			kitData.docs.forEach(asset => {
				const assetName = asset.metadata && asset.metadata.fields && asset.metadata.fields.newsroomDisplayName && asset.metadata.fields.newsroomDisplayName.length ? asset.metadata.fields.newsroomDisplayName[0] : asset.filename;
				resourcesWrapper.append(`<div class="resource_wrapper">
						<div class="icon_wrapper">${docSVG}</div>
						<div class="details_wrapper">
							<div class="resource_name">${assetName}</div>
							<div class="resource_links_wrapper">
								<span data-type="docs" data-name="${assetName}" data-id="${asset.id}" class="preview_link">Preview</span>
								<span class="divider"></span>
								<a class="download_link" target="_blank" href="${asset.embeds.document_html5_viewer.url}">Download</a>
							</div>
						</div>
					</div>`);
			});
		}
		// present kit docs, if any

		if (kitData.videos && kitData.videos.length) {
			kitData.videos.forEach(asset => {
				const assetName = asset.metadata && asset.metadata.fields && asset.metadata.fields.newsroomDisplayName && asset.metadata.fields.newsroomDisplayName.length ? asset.metadata.fields.newsroomDisplayName[0] : asset.filename;
				resourcesWrapper.append(`<div class="resource_wrapper">
						<div class="icon_wrapper">${videoSVG}</div>
						<div class="details_wrapper">
							<div class="resource_name">${assetName}</div>
							<div class="resource_links_wrapper">
								<span data-type="videos" data-name="${assetName}" data-id="${asset.id}" class="preview_link">Preview</span>
								<span class="divider"></span>
								<a class="download_link" href="${asset.embeds.original.url}">Download</a>
							</div>
						</div>
					</div>`);
			});
		}
		// present kit videos, if any

		if (kitData.images && kitData.images.length) {
			if (kitData.images.length === 1) {
				const asset = kitData.images[0];
				const assetName = asset.metadata && asset.metadata.fields && asset.metadata.fields.newsroomDisplayName && asset.metadata.fields.newsroomDisplayName.length ? asset.metadata.fields.newsroomDisplayName[0] : asset.filename;
				resourcesWrapper.append(`<div class="resource_wrapper">
						<div class="icon_wrapper">${imageSVG}</div>
						<div class="details_wrapper">
							<div class="resource_name">${assetName}</div>
							<div class="resource_links_wrapper">
								<span data-type="images" data-name="${assetName}" data-id="${asset.id}" class="preview_link">Preview</span>
								<span class="divider"></span>
								<a class="download_link" href="${asset.embeds.original.url}">Download</a>
							</div>
						</div>
					</div>`);
			}
			// single image
			else {
				resourcesWrapper.append(`<div class="resource_wrapper">
					<div class="icon_wrapper">${imagesSVG}</div>
					<div class="details_wrapper">
						<div class="resource_name">Related Photos</div>
						<div class="resource_links_wrapper">
							<span data-type="gallery" class="preview_link">Preview</span>							
							${
								kitData.imageArchive
									? `<span class="divider"></span>
								<a class="download_all_link" href="${kitData.imageArchive}">Download All</a>`
									: ""
							}
						</div>
					</div>
				</div>`);
			}
		}
		// multiple images

		$(".download_link, .download_all_link").on("click", function () {
			if (!window["ga-disable-UA-9583009-6"] && !window["ga-disable-G-CYL99NE5DN"]) {
				// google analytics not disabled
				if (typeof gtagEvent != "undefined") {
					gtagEvent($(this));
				}
			} else {
				console.error("click not tracked");
			}
		});
		// track downloads

		// MARK: Preview handling
		$(".resource_links_wrapper .preview_link").on("click", function () {
			const assetType = $(this).attr("data-type");
			if (assetType === "gallery") {
				modal(`<div id="preview_container">
						<div id="preview_asset_title">${kitData.name} Media Kit Photos</div>
						<a id="preview_download_link" href="${kitData.images[0].embeds.original.url}" target="_blank">Download</a>
						<div id="preview_nav_wrapper"><span id="preview-gallery-prev" class="preview_nav" uk-icon="icon: chevron-left;"></span><span id="preview-gallery-next" class="preview_nav" uk-icon="icon: chevron-right;"></span></div>
						<hr id="preview_rule"/>
						<div id="preview_content" class="gallery">
						${kitData.images.map((asset, index) => `<img${index ? ` class="hidden"` : ""} data-index="${index}" src="${asset.embeds.OriginalSize.url}"/>`).join("")}
						</div>
					</div>`);
				const imgs = $("#preview_content img[data-index]");
				// $("#preview_nav_wrapper").on("click", function (e) {
				// 	e.stopImmediatePropagation();
				// });
				$(".preview_nav").on("click", function () {
					const dir = $(this).attr("id") === "preview-gallery-next" ? "next" : "prev";
					const currIndex = parseInt(imgs.not(".hidden").eq(0).attr("data-index"));
					const nextIndex = dir === "next" ? (currIndex + 1 < imgs.length ? currIndex + 1 : 0) : currIndex === 0 ? imgs.length - 1 : currIndex - 1;
					imgs.addClass("hidden").eq(nextIndex).removeClass("hidden");
					$("#preview_download_link").attr({
						href: kitData.images[nextIndex].embeds.original.url,
						"data-id": kitData.images[nextIndex].filename
					});
				});
			} else {
				const assetId = $(this).attr("data-id");
				const assetName = $(this).attr("data-name");
				const asset = kitData[assetType].find(item => item.id === assetId);
				modal(`<div id="preview_container">
					<div id="preview_asset_title">${assetName}</div>
					<a id="preview_download_link" href="${assetType === "docs" ? asset.embeds.document_html5_viewer.url : assetType === "videos" || assetType === "images" ? asset.embeds.original.url : ""}" target="_blank">Download</a>
					<hr id="preview_rule"/>
					<div id="preview_content"${assetType === "videos" ? ` class="video"` : ""}>
						${assetType === "docs" ? asset.embeds.document_html5_viewer.html : assetType === "videos" ? asset.embeds.VideoWithPlayerAndDownload.html : assetType === "images" ? `<img src="${asset.thumbnails["2048px"].url}" width="100%" height="auto" />` : ""}
					</div>
				</div>`);
			}
		});
	} else {
		console.error("No kit found");
	}
};
// end presentKit function

// MARK: Present Kits LP
const presentKits = () => {
	const now = new Date().getTime();
	kitsWrapper.removeClass("hidden");
	const featuredWrapper = kitsWrapper.find("#featured_kit_wrapper");
	const kitsGrid = kitsWrapper.find("#kits_grid").html("");
	if (kits.length) {
		const featuredKit = kits[0];
		// featured kit after sortKits() should
		// be first kit in kits array

		const thisId = featuredKit.id;
		featuredWrapper.attr("data-id", thisId);
		const kitData = featuredKit.langs[lang];
		const linkWrapper = featuredWrapper.find("#featured_kit_link_wrapper");
		linkWrapper.attr("href", `/en/kits/?id=${thisId}`);
		linkWrapper.find("#featured_kit_image_wrapper").html(`<img src="${kitData.thumb && kitData.thumb.url ? kitData.thumb.url : placeholder}"/>`);
		linkWrapper.find("#featured_kit_date").html(`${humanDate(kitData.pubTime, false, " ", "MY")}${kitData.pubTime > now ? ` <span class="inactive">(Pub time: ${humanDate(kitData.pubTime, true)})</span>` : ""}`);
		linkWrapper.find("#featured_kit_headline").html(`${admin ? `<span class="pointer edit_kit_button" uk-icon="icon: pencil;ratio: 1.5"></span></span>` : ""}${kitData.name}${!kitData.status ? ` <span class="inactive">(Inactive)</span>` : ""}<span class="kit_caret">${caret_black}</span>`);
		if (kits.length - 1) {
			// there is more than one asset
			const pages = [];
			let thisPage = [];
			kits.slice(1).forEach((item, index) => {
				if (index && index % gridCt === 0) {
					pages.push(thisPage);
					thisPage = [item];
				} else {
					thisPage.push(item);
				}
			});
			if (thisPage.length) {
				pages.push(thisPage);
			}
			// create pages of kits up to gridCt in length

			pages.forEach((page, index) => {
				page.forEach(kit => {
					const page = index + 1;
					const thisId = kit.id;
					const kitData = kit.langs[lang];
					kitsGrid.removeClass("hidden").append(`<div data-id="${thisId}" class="grid_kit_wrapper${page > 1 ? " hidden" : ""}" data-page="${page}">
					<a href="/en/kits/?id=${thisId}" class="grid_kit kit_container">
				<div class="grid_kit_image_wrapper">
						<img src="${kitData.thumb && kitData.thumb.url ? kitData.thumb.url : placeholder}"/>					
					</div>
					<div class="grid_kit_copy_wrapper">
						<div class="grid_kit_date">${`${humanDate(kitData.pubTime, false, " ", "MY")}${kitData.pubTime > now ? ` <span class="inactive">(Pub time: ${humanDate(kitData.pubTime, true)})</span>` : ""}`}</div>
						<div class="grid_kit_headline">${admin ? `<span class="grid_kit_admin_wrapper"><span class="pointer edit_kit_button" uk-icon="icon: pencil; ratio: 1.5"></span></span>` : ""}${kitData.name}${!kitData.status ? ` <span class="inactive">(Inactive)</span>` : ""}<span class="kit_caret">${caret_black}</span></div>
					</div>
				</a>				
			</div>`);
				});
			});
			const loadBtn = loadMoreBtnWrapper.find("button");
			if (pages.length > 1) {
				loadMoreBtnWrapper.removeClass("hidden");
				loadBtn.off("click").on("click", function () {
					const next = parseInt(loadBtn.attr("data-nextpage"));
					kitsGrid.find(`.grid_kit_wrapper[data-page='${next}']`).removeClass("hidden");
					// reveal next page of kits

					if (pages[next]) {
						loadBtn.attr("data-nextpage", next + 1);
						// update button
					} else {
						loadMoreBtnWrapper.addClass("hidden");
					}
				});
			}
		}

		// MARK: Edit / delete kits handlers
		$(".edit_kit_button")
			.off("click")
			.on("click", function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				id = $(this).parents("[data-id]").attr("data-id");
				kitButton.trigger("click", { id: id });
			});

		// MARK: Sort kits handler
		$("#sortKitsButton")
			.off("click")
			.on("click", function () {
				const sortModal = modal(`<h3>Sort kits</h3>
		<p>Drag and drop kits to update their order</p>
		<div id="sorting_kit_container" class="um-margin-small-top" uk-sortable>
			${kits
				.map(
					kit => `<div data-id="${kit.id}" class="sorting_kit">
					<div class="sorting_kit_image_wrapper">
						<img src="${kit.langs[lang].thumb && kit.langs[lang].thumb.url ? kit.langs[lang].thumb.url : placeholder}"/>
					</div>
					<div class="sorting_kit_name">${kit.langs[lang].name}</div>
				</div>`
				)
				.join("")}
		</div>
		<div class="uk-margin-top">
				<button class="uk-button uk-button-primary uk-position-relative" id="sorting_kit_save_button">Save Order</button>
				<button class="uk-button uk-button-danger uk-modal-close" id="sorting_kit_cancel_button">Cancel</button>
		</div>`);
				$("#sorting_kit_save_button").on("click", async function () {
					const submitBtn = $(this);
					const kitsInDOM = $("#sorting_kit_container .sorting_kit");
					const indexedKits = [];
					kitsInDOM.each(function (index) {
						const kit = kits.find(item => item.id === $(this).attr("data-id"));
						kit.langs[lang].sortIndex = index;
						indexedKits.push({
							PutRequest: {
								Item: kit
							}
						});
					});
					try {
						await request(
							{
								reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
								data: indexedKits
							},
							submitBtn
						);
						notify("Kit order saved", "success");
						sortKits();
						presentKits();
						UIkit.modal(sortModal).hide();
					} catch (err) {
						console.error(err);
						notify("There was an error updating the Media Kit sort", "danger");
					}
				});
			});
	} else {
		featuredWrapper.html(`<h3 class="uk-text-center">There are no media kits available.</h3>`);
	}
};
// end presentKits function

$(window).on("resize", function () {
	let build = kitsWrapper.attr("build");
	build = build === "undefined" ? (window.isMobile ? "mobile" : "desktop") : build;
	if (id) {
		// if single-kit view,
		// rebuild kit vew if view changes from desktop to mobile or vice versa

		if ((window.isMobile && build != "mobile") || (!window.isMobile && build != "desktop")) {
			presentKit(kits);
		}
	} else {
		// if not single-kit view,
		// rebuild kit gallery on mobile <-> non-mobile change

		$(window).on("resize", function () {
			perPage = 4;
			pageNo = 1;
			let build = kitsWrapper.attr("build");
			build = build === "undefined" ? (window.isMobile ? "mobile" : "desktop") : build;
			if ((window.isMobile && build != "mobile") || (!window.isMobile && build != "desktop")) {
				presentKits(kits);
			}
		});
	}
});
